import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import FidcService from '../../../../services/fidcService';

const rotulos: Record<string, string> = {
  nome: 'Nome', codigoExterno: 'Código externo', cnpj: 'CNPJ', prioridade: 'Prioridade',
  limiteDiario: 'Limite diário', ativo: 'Ativo', disponivel: 'Disponível', banco: 'Banco',
  agencia: 'Agência', conta: 'Conta', tipoContrato: 'Tipo de contrato', elegibilidade: 'Elegibilidade',
  regimes: 'Regimes', produtos: 'Produtos (IDs)', empregadores: 'Convênios (IDs)',
  originadores: 'Originadores (IDs)', idadeMaxima: 'Idade máxima', prazoMaximo: 'Prazo máximo',
  taxas: 'Taxas de cessão', empregador: 'Convênio', regime: 'Regime',
  jurosOperacao: 'Juros da operação', taxaCessao: 'Taxa de cessão', id: 'ID'
};
function campos(texto?: string): Record<string, string> {
  if (!texto) return {};
  try {
    const valor = JSON.parse(texto);
    if (!valor || typeof valor !== 'object') return { Registro: String(valor) };
    const resultado: Record<string, string> = {};
    const percorrer = (obj: any, prefixo = '') => Object.entries(obj).forEach(([chave, v]) => {
      const nome = prefixo + (rotulos[chave] || chave);
      if (v && typeof v === 'object' && !Array.isArray(v)) percorrer(v, nome + ' / ');
      else if (Array.isArray(v)) resultado[nome] = v.map(item => typeof item === 'object'
        ? Object.entries(item).map(([k, val]) => (rotulos[k] || k) + ': ' + val).join(', ')
        : String(item)).join(' · ') || '—';
      else resultado[nome] = v == null ? '—' : typeof v === 'boolean' ? (v ? 'Sim' : 'Não')
        : chave === 'limiteDiario' ? Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : String(v);
    });
    percorrer(valor); return resultado;
  } catch { return { Registro: texto }; }
}
export default function FidcHistorico({ id, nome, onHide }: { id: string | number; nome: string; onHide: () => void }) {
  const [historico, setHistorico] = useState<any[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  useEffect(() => {
    let ativo = true;
    setCarregando(true); setErro(''); setHistorico([]);
    new FidcService().historico(id).then(r => { if (ativo) setHistorico(r.data); })
      .catch(() => { if (ativo) setErro('Não foi possível carregar o histórico. Feche e tente novamente.'); })
      .finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [id]);
  return <Modal show onHide={onHide} size="xl" centered scrollable aria-labelledby="titulo-historico-fidc">
    <Modal.Header closeButton><Modal.Title id="titulo-historico-fidc">Histórico de alterações do FIDC</Modal.Title></Modal.Header>
    <Modal.Body>
      <p><strong>{nome}</strong> — Código {id}</p>
      {carregando && <p role="status">Carregando histórico...</p>}
      {erro && <div role="alert" className="alert alert-danger">{erro}</div>}
      {!carregando && !erro && !historico.length && <p>Nenhuma alteração registrada.</p>}
      {historico.map(h => {
        const antes = campos(h.anterior), depois = campos(h.atual);
        const chaves = Array.from(new Set([...Object.keys(antes), ...Object.keys(depois)]));
        const usuario = /\.Usuario@/.test(h.usuario || '') ? 'Usuário não identificado no registro antigo' : h.usuario || 'Sistema';
        return <article className="card mb-3" key={h.id}>
          <div className="card-header"><strong>Registro #{h.id}</strong> — {h.dataHora ? new Date(h.dataHora).toLocaleString('pt-BR') : 'Data não informada'} — {usuario}</div>
          <div className="card-body">
            <p><strong>Motivo / ação:</strong> {h.justificativa || 'Não informado'}</p>
            <div className="table-responsive"><table className="table table-bordered table-sm">
              <thead><tr><th>Campo</th><th>Antes</th><th>Depois</th></tr></thead>
              <tbody>{chaves.map(chave => <tr key={chave} className={antes[chave] !== depois[chave] ? 'table-warning' : ''}>
                <th scope="row">{chave}</th><td style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{antes[chave] || '—'}</td>
                <td style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{depois[chave] || '—'}</td>
              </tr>)}</tbody>
            </table></div>
            <small>Campos alterados destacados em amarelo.</small>
          </div>
        </article>;
      })}
    </Modal.Body>
    <Modal.Footer><Button variant="secondary" onClick={onHide}>Fechar</Button></Modal.Footer>
  </Modal>;
}
